import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"

import ApplicationFilter from "components/Filter/ApplicationFilter"

// components
import Applications from "pages/Dashboard/applications"

// services
import ApplicationService from "../../services/applications/Application.service"
import Staff from "services/staff/Staff"

let appService = null
let plasticsUser = null
let staffService = new Staff()

const Processing = () => {
  const [menu, setMenu] = useState(false)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [processing, setprocessing] = useState()
  const [searchMode, setsearchMode] = useState(false)
  const [filterValues, setFilterValues] = useState({
    search: "",
    application_status: "",
    date_from: "",
    date_to: "",
  })

  const toggle = () => {
    setMenu(!menu)
  }

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    appService = new ApplicationService(userObj)

    setuser(userObj)
    plasticsUser = appService.getStrategy("head")
    plasticsUser.getProcessingApplications(1).then(response => {
      if (response.status) {
        setprocessing(response.data)
        setmounted(true)
      }
    })
  }, [])

  const paginate = page => {
    // If we are in search mode, we will call the search endpoint instead
    if (searchMode) {
      appService.searchApplications(filterValues, page).then(response => {
        setprocessing(response.data)
      })
    } else {
      plasticsUser.getProcessingApplications(page).then(response => {
        if (response.status) {
          setprocessing(response.data)
        }
      })
    }
  }

  const initiateSearch = data => {
    data = { ...data, application_status: "SUBMITTED,REVIEWED,UNDER REVIEW,DEPARTMENT APPROVED,SENT_BACK_HoD,SENT_BACK_DG,RETURN TO APPLICANT,PROPOSE TO APPROVE,PROPOSE TO REJECT,PROPOSE TO RETURN BACK,DEPARTMENT_REJECTED" }
    setsearchMode(true)
    setFilterValues(data)
    appService.searchApplications(data, null).then(response => {
      if (response?.code && response.code == 200) {
        if (response.data.total == 0) {
          setprocessing({ data: [] })
        } else {
          setprocessing(response.data)
        }
      } else {
        setprocessing({ data: [] })
      }
    })
  }

  const turnOffSearchMode = () => {
    setsearchMode(false)
    paginate(0)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Processing | Staff</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Processing</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    All processing applications will show up here.
                  </li>
                </ol>
              </Col>
            </Row>
          </div>

          {mounted ? (
            <Row>
              <ApplicationFilter
                allApplications={false}
                handleSearch={initiateSearch}
                turnOffSearch={turnOffSearchMode}
              />

              <Applications
                viewOnly={true}
                user={user}
                data={processing}
                paginate={paginate}
                showReassignStaffBtn={true}
              />
            </Row>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Processing
